import React, { useEffect, useState, useRef } from "react";
import { AxiosError } from "axios";
import {
  Datum,
  activitiesReqirePreApprovals,
} 
from "../../interface/ActivitiesReqirePreApprovals";
import { ColumnDef } from "@tanstack/react-table";
import { Button } from "../../components/ui/button";
import { ActivitiesReqirePreApprovalsAxiosInstance } from "../../Network/ActivitiesReqirePreApprovalsAxiosInstance";
import { Option } from "../../interface/Option";
import { LoginAxiosInstance } from "../../Network/LoginAxiosInstance";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/Label";
import { Toaster } from "../../components/ui/toaster";
import { useToast } from "../../hooks/use-toast";
import DataTable2 from "shared/DataTable2";
import UnifiedSearchBox from "../../shared/UnifiedSearchBox";
import ServerDeletedPills from "shared/ServerDeletedPills";
import { ServerDeletedFilterValue } from "shared/ServerListFilters";
import { useServerPaginatedList } from "../../shared/useServerPaginatedList";
import ListOfNewNetworkName from "../Shared/NewNetworkName";
import ListOfInsuranceplanName from "../Shared/ListOfInsuranceplanName";
import ListofActivityCode from "../Shared/ListOfActivityCode";
import ListOfActivityMedical from "../Shared/ListOfActivityMedical";
import ListOfActivityCustom from "../Shared/ListOfActivityCustom";
import VipPatientSelector from "Pages/Shared/VipPatient";
import ListOfProviderName from "../Shared/ListOfProviderName";
import PolicyNames from "../Shared/PolicyNames";
import FileUpload from "Pages/uploadFile/ActivitiesReqirePreApprovals/ActivitiesReqirePreApprovals";
import ListOfDoctorName from "../Shared/Doctor";
import Vip from "../Shared/Vip";
import ListOfSpecialtyName from "../Shared/Specialty";
import useQaAutomationIds from "../../utils/useQaAutomationIds";

export interface PolicyItem {
  id?: number;
  Policy_id: string;
  Policy_name: string;
  plans?: Array<{
    Plan_name?: string;
    plan_name?: string;
    name?: string;
    id?: number;
    [key: string]: any;
  }>;
}

interface CodeWithType {
  code: string;
  type: string;
}

type ActivitiesByType = { CPT: Option[]; HCPCS: Option[]; Dental: Option[]; Drugs: Option[] };
const EMPTY_BY_TYPE: ActivitiesByType = { CPT: [], HCPCS: [], Dental: [], Drugs: [] };

// â”€â”€â”€ preserveScroll helper â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const preserveScrollCheckbox = (e: React.ChangeEvent<HTMLInputElement>, fn: () => void) => {
  const el = e.currentTarget as HTMLElement;
  const dialog = el.closest('[role="dialog"]');
  const scrollable = dialog?.querySelector('.overflow-y-auto') as HTMLElement | null;
  const scrollTop = scrollable?.scrollTop ?? 0;
  fn();
  requestAnimationFrame(() => {
    if (scrollable) scrollable.scrollTop = scrollTop;
  });
};
const getUserRole = (): string => {
  try {
    const token = localStorage.getItem("token") || "";
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.userType || "";
  } catch { return ""; }
};

// â”€â”€â”€ EntityCard â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const colors: Record<string, { border: string; bg: string; text: string; badgeBg: string }> = {
  blue:    { border: "border-blue-200",    bg: "bg-blue-50",    text: "text-blue-700",    badgeBg: "bg-blue-50 text-blue-700 border-blue-200" },
  cyan:    { border: "border-cyan-200",    bg: "bg-cyan-50",    text: "text-cyan-700",    badgeBg: "bg-cyan-50 text-cyan-700 border-cyan-200" },
  purple:  { border: "border-purple-200",  bg: "bg-purple-50",  text: "text-purple-700",  badgeBg: "bg-purple-50 text-purple-700 border-purple-200" },
  amber:   { border: "border-amber-200",   bg: "bg-amber-50",   text: "text-amber-700",   badgeBg: "bg-amber-50 text-amber-700 border-amber-200" },
  emerald: { border: "border-emerald-200", bg: "bg-emerald-50", text: "text-emerald-700", badgeBg: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  pink:    { border: "border-pink-200",    bg: "bg-pink-50",    text: "text-pink-700",    badgeBg: "bg-pink-50 text-pink-700 border-pink-200" },
  yellow:  { border: "border-yellow-200",  bg: "bg-yellow-50",  text: "text-yellow-700",  badgeBg: "bg-yellow-50 text-yellow-700 border-yellow-200" },
  indigo:  { border: "border-indigo-200",  bg: "bg-indigo-50",  text: "text-indigo-700",  badgeBg: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  slate:   { border: "border-slate-200",   bg: "bg-slate-50",   text: "text-slate-700",   badgeBg: "bg-slate-50 text-slate-700 border-slate-200" },
  teal:    { border: "border-teal-200",    bg: "bg-teal-50",    text: "text-teal-700",    badgeBg: "bg-teal-50 text-teal-700 border-teal-200" },
};

interface EntityCardProps {
  label: string;
  icon: string;
  color: string;
  isActive: boolean;
  mode: "EXCLUSION" | "INCLUSION" | null;
  onExclusion: () => void;
  onInclusion: () => void;
  onClear: () => void;
  children: React.ReactNode;
}

const EntityCard: React.FC<EntityCardProps> = ({
  label, icon, color, isActive, mode, onExclusion, onInclusion, onClear, children,
}) => {
  const c = colors[color] ?? colors.slate;

  const preserveScroll = (fn: () => void) => (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const dialog = (e.currentTarget as HTMLElement).closest('[role="dialog"]');
    const scrollable = dialog?.querySelector('.overflow-y-auto') as HTMLElement | null;
    const scrollTop = scrollable?.scrollTop ?? 0;
    fn();
    requestAnimationFrame(() => {
      if (scrollable) scrollable.scrollTop = scrollTop;
    });
  };

  return (
    <div className={`bg-white rounded-xl border p-4 transition-all relative ${isActive ? `${c.border} shadow-sm` : "border-slate-100"}`}>
      {isActive && (
        <button
          type="button"
          onClick={preserveScroll(onClear)}
          className="absolute top-2 right-2 w-7 h-7 flex items-center justify-center rounded-full bg-slate-50 text-slate-400 hover:bg-red-50 hover:text-red-500 transition-all border border-slate-100 shadow-sm z-10"
          title="Clear"
        >
          <i className="fa-solid fa-xmark text-[14px]"></i>
        </button>
      )}
      <div className="flex flex-col items-center gap-4">
        <span className={`px-4 py-1 rounded-full text-[10px] font-black tracking-tighter border flex items-center gap-2 ${isActive ? c.badgeBg : "bg-slate-50 text-slate-400 border-slate-200"}`}>
          <i className={`fa-solid ${icon} text-[12px]`}></i> {label}
        </span>
        <div className="flex bg-slate-100/80 rounded-lg p-1 border border-slate-200 w-full shadow-inner">
          <button
            type="button"
            onClick={preserveScroll(onExclusion)}
            className={`flex-1 py-2 text-[11px] font-bold rounded-md transition-all ${isActive && mode === "EXCLUSION" ? "bg-red-600 text-white shadow-md" : "text-slate-500 hover:bg-slate-200"}`}
          >
            Exclusion
          </button>
          <button
            type="button"
            onClick={preserveScroll(onInclusion)}
            className={`flex-1 py-2 text-[11px] font-bold rounded-md transition-all ${isActive && mode === "INCLUSION" ? "bg-emerald-600 text-white shadow-md" : "text-slate-500 hover:bg-slate-200"}`}
          >
            Inclusion
          </button>
        </div>
      </div>
      {isActive && (
        <div className="mt-4 pt-4 border-t border-slate-100 space-y-3">
          {children}
        </div>
      )}
    </div>
  );
};

// â”€â”€â”€ mode conversion helpers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const cardToMode = (mode: "EXCLUSION" | "INCLUSION" | null): string => {
  if (mode === "EXCLUSION") return "EXCLUDED";
  if (mode === "INCLUSION") return "INCLUDED";
  return "DISABLED";
};

const modeToCard = (mode: string | undefined): "EXCLUSION" | "INCLUSION" | null => {
  if (mode === "EXCLUDED") return "EXCLUSION";
  if (mode === "INCLUDED") return "INCLUSION";
  return null;
};

// â”€â”€â”€ Helpers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const TYPE_MAP: Record<string, string> = {
  cpt: "CPT", CPT: "CPT",
  hcpcs: "HCPCS", HCPCS: "HCPCS",
  dental: "Dental", Dental: "Dental",
  drugs: "Drugs", Drugs: "Drugs",
};

const getActivityTypeColor = (type: string) => {
  const cols: Record<string, { bg: string; border: string; text: string }> = {
    CPT:    { bg: "bg-blue-100",   border: "border-blue-500",   text: "text-blue-900" },
    HCPCS:  { bg: "bg-green-100",  border: "border-green-500",  text: "text-green-900" },
    Dental: { bg: "bg-purple-100", border: "border-purple-500", text: "text-purple-900" },
    Drugs:  { bg: "bg-orange-100", border: "border-orange-500", text: "text-orange-900" },
  };
  return cols[type] || { bg: "bg-gray-100", border: "border-gray-500", text: "text-gray-900" };
};

const normalizeItem = (item: any): any => {
  let activity_types: CodeWithType[] = [];
  if (Array.isArray(item.activity_types) && item.activity_types.length > 0 && typeof item.activity_types[0] === "object" && "code" in item.activity_types[0]) {
    activity_types = item.activity_types.map((at: any) => ({ code: at.code, type: TYPE_MAP[at.type?.toLowerCase()] || at.type || "CPT" }));
  } else if (Array.isArray(item.activity_code) && item.activity_code.length > 0 && Array.isArray(item.activity_type)) {
    activity_types = item.activity_code.map((code: string, idx: number) => {
      const rawType = item.activity_type[idx] || item.activity_type[0] || "cpt";
      return { code, type: TYPE_MAP[rawType?.toLowerCase()] || "CPT" };
    });
  }
  return { ...item, activity_types };
};

const flattenByType = (byType: ActivitiesByType): CodeWithType[] => {
  const result: CodeWithType[] = [];
  Object.entries(byType).forEach(([type, options]) => {
    options.forEach((o) => result.push({ code: o.value as string, type }));
  });
  return result;
};

const groupByType = (items: CodeWithType[]): ActivitiesByType => {
  const grouped: ActivitiesByType = { CPT: [], HCPCS: [], Dental: [], Drugs: [] };
  items.forEach(({ code, type }) => {
    const key = TYPE_MAP[type] as keyof ActivitiesByType;
    if (key && grouped[key]) grouped[key].push({ value: code, label: code });
  });
  return grouped;
};

// â”€â”€â”€ SectionCard â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const SectionCard: React.FC<{ num: number; title: string; subtitle?: string; children: React.ReactNode }> = ({ num, title, subtitle, children }) => (
  <div className="border border-gray-200 rounded-xl overflow-hidden mb-4 bg-white shadow-sm">
    <div className="flex items-center gap-3 px-5 py-3 bg-gray-50 border-b border-gray-200">
      <span className="w-6 h-6 rounded-full bg-blue-700 text-white text-xs font-semibold flex items-center justify-center flex-shrink-0">{num}</span>
      <div>
        <p className="text-sm font-semibold text-gray-800">{title}</p>
        {subtitle && <p className="text-xs text-gray-500">{subtitle}</p>}
      </div>
    </div>
    <div className="p-5">{children}</div>
  </div>
);

// â”€â”€â”€ ActivityTypeCell â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const ActivityTypeCell: React.FC<{
  items: CodeWithType[];
  groups?: string[];
  searchTerm?: string;
  onShowAll: (items: CodeWithType[], groups: string[]) => void;
}> = ({ items, groups = [], searchTerm = "", onShowAll }) => {
  if (items.length === 0 && groups.length === 0)
    return <div className="w-full text-center text-gray-400">â€”</div>;

  const allDisplay = [
    ...items.map((item) => ({
      label: item.code,
      type: item.type,
      isGroup: false,
      originalItem: item,
    })),
    ...groups.map((group) => ({
      label: group,
      type: "Group",
      isGroup: true,
      originalItem: null,
    })),
  ];

  const normalizedSearch = searchTerm.toLowerCase().trim();
  const hasSearch = normalizedSearch.length >= 2;

  const matchingDisplay = hasSearch
    ? allDisplay.filter((entry) =>
        entry.label.toLowerCase().includes(normalizedSearch),
      )
    : [];

  const hasMatches = hasSearch && matchingDisplay.length > 0;
  const displaySource = hasMatches ? matchingDisplay : allDisplay;
  const display = displaySource.slice(0, 3);
  const remainingCount = Math.max(0, displaySource.length - display.length);

  const dialogItems = hasMatches
    ? matchingDisplay
        .filter((entry) => !entry.isGroup && entry.originalItem)
        .map((entry) => entry.originalItem as CodeWithType)
    : items;

  const dialogGroups = hasMatches
    ? matchingDisplay
        .filter((entry) => entry.isGroup)
        .map((entry) => entry.label)
    : groups;

  return (
    <div className="w-full px-2 py-1.5">
      <div className="flex flex-wrap justify-center gap-1.5 mb-1.5">
        {display.map((entry, index) => {
          const isMatching =
            hasSearch &&
            entry.label.toLowerCase().includes(normalizedSearch);

          const defaultColor = entry.isGroup
            ? {
                bg: "bg-slate-50",
                border: "border-slate-400",
                text: "text-slate-700",
              }
            : getActivityTypeColor(entry.type);

          const color = isMatching
            ? {
                bg: "bg-yellow-200",
                border: "border-yellow-400",
                text: "text-yellow-900",
              }
            : defaultColor;

          return (
            <div
              key={`${entry.type}-${entry.label}-${index}`}
              className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-md border ${color.bg} ${color.border}`}
            >
              <span className={`font-semibold text-xs ${color.text}`}>
                {entry.label}
              </span>
              <span
                className={`text-[9px] font-bold uppercase ${color.text} opacity-75`}
              >
                {entry.isGroup ? "GRP" : entry.type}
              </span>
            </div>
          );
        })}
      </div>

      <div className="flex items-center justify-between border-t border-gray-100 pt-1">
        <span className="text-xs font-bold text-gray-500">
          {hasMatches
            ? `${matchingDisplay.length}/${allDisplay.length}`
            : allDisplay.length}
        </span>

        {remainingCount > 0 && (
          <button
            onClick={(event) => {
              event.stopPropagation();
              onShowAll(dialogItems, dialogGroups);
            }}
            className={`text-[11px] font-semibold ${
              hasMatches
                ? "text-yellow-600 hover:text-yellow-800"
                : "text-blue-600 hover:text-blue-800"
            }`}
          >
            +{remainingCount} more â†’
          </button>
        )}
      </div>
    </div>
  );
};

// â”€â”€â”€ Main Component â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const ActivitiesReqirePreApprovals: React.FC = () => {
  useQaAutomationIds("activity-pre-approvals");
  const [items, setItems] = useState<{ data: any[] }>({ data: [] });

  // â”€â”€ form: basic â”€â”€
  const [relationName, setRelationName] = useState<string>("");
  const [isActive, setIsActive] = useState<boolean>(true);

  // â”€â”€ form: activity â”€â”€
  const [selectedMainOption, setSelectedMainOption] = useState<string | null>(null);
  const [activitiesByType, setActivitiesByType] = useState<ActivitiesByType>({ ...EMPTY_BY_TYPE });
  const [customActivityGroups, setCustomActivityGroups] = useState<Option[]>([]);
  const [medicalActivityGroups, setMedicalActivityGroups] = useState<Option[]>([]);
  // â”€â”€ Entities toggle â”€â”€
  const [showEntities, setShowEntities] = useState(false);

  // â”€â”€ Provider â”€â”€
  const [provider, setProvider] = useState<Option[]>([]);
  const [providerMode, setProviderMode] = useState<"EXCLUSION" | "INCLUSION" | null>(null);
  const [isProviderActive, setIsProviderActive] = useState(false);
  const [selectAllProviders, setSelectAllProviders] = useState(false);

  // â”€â”€ Doctor â”€â”€
  const [doctor, setDoctor] = useState<Option[]>([]);
  const [doctorMode, setDoctorMode] = useState<"EXCLUSION" | "INCLUSION" | null>(null);
  const [isDoctorActive, setIsDoctorActive] = useState(false);
  const [selectAllDoctor, setSelectAllDoctor] = useState(false);

  // â”€â”€ Networks â”€â”€
  const [networks, setNetworks] = useState<Option[]>([]);
  const [networkMode, setNetworkMode] = useState<"EXCLUSION" | "INCLUSION" | null>(null);
  const [isNetworkActive, setIsNetworkActive] = useState(false);
  const [selectAllNetworks, setSelectAllNetworks] = useState(false);

  // â”€â”€ Insurance Plan â”€â”€
  const [insuranceplan, setInsuranceplan] = useState<Option[]>([]);
  const [insuranceMode, setInsuranceMode] = useState<"EXCLUSION" | "INCLUSION" | null>(null);
  const [isInsuranceActive, setIsInsuranceActive] = useState(false);
  const [selectAllInsurance, setSelectAllInsurance] = useState(false);

  // â”€â”€ Payer â”€â”€
  const [Payer, setPayer] = useState<string[]>([]);
  const [payerMode, setPayerMode] = useState<"EXCLUSION" | "INCLUSION" | null>(null);
  const [isPayerActive, setIsPayerActive] = useState(false);
  const [selectAllPayer, setSelectAllPayer] = useState(false);

  // â”€â”€ Policy â”€â”€
  const [policy, setPolicy] = useState<PolicyItem[]>([]);
  const [policyMode, setPolicyMode] = useState<"EXCLUSION" | "INCLUSION" | null>(null);
  const [isPolicyActive, setIsPolicyActive] = useState(false);
  const [selectAllPolicy, setSelectAllPolicy] = useState(false);

  // â”€â”€ Patients â”€â”€
  const [patients, setPatients] = useState<Option[]>([]);
  const [patientMode, setPatientMode] = useState<"EXCLUSION" | "INCLUSION" | null>(null);
  const [isPatientActive, setIsPatientActive] = useState(false);
  const [selectAllPatients, setSelectAllPatients] = useState(false);

  // â”€â”€ VIP â”€â”€
  const [vip, setVip] = useState<Option[]>([]);
  const [vipMode, setVipMode] = useState<"EXCLUSION" | "INCLUSION" | null>(null);
  const [isVipActive, setIsVipActive] = useState(false);
  const [selectAllVip, setSelectAllVip] = useState(false);

  // â”€â”€ User Level â”€â”€
  const [userLevel, setUserLevel] = useState<string[]>([]);
  const [userMode, setUserMode] = useState<"EXCLUSION" | "INCLUSION" | null>(null);
  const [isUserActive, setIsUserActive] = useState(false);
  const [selectAllUser, setSelectAllUser] = useState(false);

  // â”€â”€ Specialty â”€â”€
  const [specialty, setSpecialty] = useState<Option[]>([]);
  const [specialtyMode, setSpecialtyMode] = useState<"EXCLUSION" | "INCLUSION" | null>(null);
  const [isSpecialtyActive, setIsSpecialtyActive] = useState(false);
  const [selectAllSpecialty, setSelectAllSpecialty] = useState(false);

  // clear flags
  const [clearProvider, setClearProvider] = useState(false);
  const [clearDoctor, setClearDoctor] = useState(false);
  const [clearNetworks, setClearNetworks] = useState(false);
  const [clearInsuranceplan, setClearInsuranceplan] = useState(false);
  const [clearPatient, setClearPatient] = useState(false);
  const [clearPolicy, setClearPolicy] = useState(false);
  const [clearVip, setClearVip] = useState(false);
  const [clearSpecialty, setClearSpecialty] = useState(false);

  // â”€â”€ dialog â”€â”€
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [editIndex, setEditIndex] = useState<null | number>(null);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any | null>(null);

  // â”€â”€ All codes popup â”€â”€
  const [allCodesOpen, setAllCodesOpen] = useState(false);
  const [allCodesItems, setAllCodesItems] = useState<CodeWithType[]>([]);
  const [allCodesGroups, setAllCodesGroups] = useState<string[]>([]);
  const [allCodesTitle, setAllCodesTitle] = useState("");

  // â”€â”€ filters â”€â”€
  const [filterSearch, setFilterSearch] = useState<string>("");
  const [filterStatus, setFilterStatus] = useState<string>("");
  const [deletedFilter, setDeletedFilter] = useState<ServerDeletedFilterValue>("false");
  const [usersMap, setUsersMap] = useState<Record<number, string>>({});

  const token = localStorage.getItem("token") || "";
  const { toast } = useToast();

  useEffect(() => { fetchUsers(); }, []);
  const userRole = getUserRole();
const canManageDeleted = userRole === "system_admin" || userRole === "super_super_admin";

const [forceDialogOpen, setForceDialogOpen] = useState(false);
const [forceId, setForceId] = useState<string | number | null>(null);
const [forceError, setForceError] = useState<string>("");
const [forceAction, setForceAction] = useState<"softDelete" | "hardDelete" | null>(null);
const [showAllUpdates, setShowAllUpdates] = useState(false);
  // â”€â”€ FIX: Reset clear flags after one render â”€â”€
useEffect(() => {
  if (clearProvider)      setClearProvider(false);
  if (clearDoctor)        setClearDoctor(false);
  if (clearNetworks)      setClearNetworks(false);
  if (clearInsuranceplan) setClearInsuranceplan(false);
  if (clearPatient)       setClearPatient(false);
  if (clearPolicy)        setClearPolicy(false);
  if (clearVip)           setClearVip(false);
  if (clearSpecialty)     setClearSpecialty(false);
}, [clearProvider, clearDoctor, clearNetworks, clearInsuranceplan,
    clearPatient, clearPolicy, clearVip, clearSpecialty]);

  // â”€â”€ FIX #2: Reset clear flags to false after one render â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  // Without this, the flags stay true permanently and keep wiping child
  // component selections on every re-render.


  // â”€â”€ Reset all entity states â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const resetAllEntityStates = () => {
    setProvider([]); setProviderMode(null); setIsProviderActive(false); setSelectAllProviders(false);
    setDoctor([]); setDoctorMode(null); setIsDoctorActive(false); setSelectAllDoctor(false);
    setNetworks([]); setNetworkMode(null); setIsNetworkActive(false); setSelectAllNetworks(false);
    setInsuranceplan([]); setInsuranceMode(null); setIsInsuranceActive(false); setSelectAllInsurance(false);
    setPayer([]); setPayerMode(null); setIsPayerActive(false); setSelectAllPayer(false);
    setPolicy([]); setPolicyMode(null); setIsPolicyActive(false); setSelectAllPolicy(false);
    setPatients([]); setPatientMode(null); setIsPatientActive(false); setSelectAllPatients(false);
    setVip([]); setVipMode(null); setIsVipActive(false); setSelectAllVip(false);
    setUserLevel([]); setUserMode(null); setIsUserActive(false); setSelectAllUser(false);
    setSpecialty([]); setSpecialtyMode(null); setIsSpecialtyActive(false); setSelectAllSpecialty(false);
    setClearProvider(true); setClearDoctor(true); setClearNetworks(true);
    setClearInsuranceplan(true); setClearPatient(true); setClearPolicy(true);
    setClearVip(true); setClearSpecialty(true);
  };

  const handleToggleEntities = () => {
    if (showEntities) resetAllEntityStates();
    setShowEntities((prev) => !prev);
  };

  const validateEntities = (): string | null => {
    const checks = [
      { isActive: isProviderActive,   hasData: selectAllProviders || provider.length > 0,     label: "Providers" },
      { isActive: isDoctorActive,     hasData: selectAllDoctor    || doctor.length > 0,        label: "Doctor" },
      { isActive: isNetworkActive,    hasData: selectAllNetworks  || networks.length > 0,      label: "Networks" },
      { isActive: isInsuranceActive,  hasData: selectAllInsurance || insuranceplan.length > 0, label: "Insurance Plan" },
      { isActive: isPolicyActive,     hasData: selectAllPolicy    || policy.length > 0,        label: "Policy" },
      { isActive: isPatientActive,    hasData: selectAllPatients  || patients.length > 0,      label: "Patients" },
      { isActive: isVipActive,        hasData: selectAllVip       || vip.length > 0,           label: "VIP" },
      { isActive: isSpecialtyActive,  hasData: selectAllSpecialty || specialty.length > 0,     label: "Specialty" },
      { isActive: isPayerActive,      hasData: selectAllPayer     || Payer.length > 0,         label: "Payer" },
      { isActive: isUserActive,       hasData: selectAllUser      || userLevel.length > 0,     label: "User Level" },
    ];
    const empty = checks.filter(c => c.isActive && !c.hasData).map(c => c.label);
    if (empty.length >= 1) {
      return `The following cards are open but have no data selected: ${empty.join(", ")}. Please select at least one item for each, or close them using the âœ• button.`;
    }
    return null;
  };

  // â”€â”€ clear â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const clear = () => {
    setRelationName("");
    setActivitiesByType({ ...EMPTY_BY_TYPE });
    setCustomActivityGroups([]);
    setMedicalActivityGroups([]);
    setSelectedMainOption(null);
    setIsActive(true);
    setShowEntities(false);
    resetAllEntityStates();
  };

  // â”€â”€ fetch â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

  const {
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
    totalPages,
    totalCount,
    allowedPageSizes,
    isTableLoading,
    manualPagination,
    fetchItems,
  } = useServerPaginatedList<any, { search: string; status: string; deleted: ServerDeletedFilterValue }>({
    filters: { search: filterSearch, status: filterStatus, deleted: deletedFilter },
    fetchPage: ({ page, limit, filters }) =>
      ActivitiesReqirePreApprovalsAxiosInstance.get(
        "getActivityPreApproved",
        {
          params: {
            page,
            limit,
            name: filters.search.trim() || undefined,
            activity: filters.search.trim() || undefined,
            disease: filters.search.trim() || undefined,
            is_active: filters.status === "true" || filters.status === "false" ? filters.status : undefined,
            is_deleted: filters.deleted,
          },
        }
      ),
    setRows: (rows) => setItems({ data: rows }),
    normalizeRow: normalizeItem,
    sortRows: (rows) =>
      [...rows]
        .sort((a: any, b: any) => Number(b.id) - Number(a.id))
        .sort((a: any, b: any) =>
          a.is_deleted === b.is_deleted ? 0 : a.is_deleted ? 1 : -1
        ),
    onError: (error) => {
      console.error("Error fetching Activities Require Pre Approvals.", error);
      toast({
        title: "Error",
        description: "Error fetching Activities Require Pre Approvals.",
        variant: "destructive",
      });
    },
  });

  const fetchUsers = async () => {
    try {
      const res = await LoginAxiosInstance.get("/");
      const raw: any[] = res.data?.users ?? res.data?.user ?? res.data ?? [];
      const map: Record<number, string> = {};
      raw.forEach((u: any) => { if (u.id != null) map[Number(u.id)] = u.name ?? u.username ?? String(u.id); });
      setUsersMap(map);
    } catch {}
  };

  const resolveUserName = (val: any): string => {
    if (val == null) return "â€”";
    if (typeof val === "object") return val.name ?? val.username ?? "â€”";
    if (typeof val === "string" && isNaN(Number(val))) return val;
    return usersMap[Number(val)] ?? String(val);
  };

  // â”€â”€ filtered data â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

  const handleOpenDialog = (item: any) => { setSelectedItem(normalizeItem(item)); setViewDialogOpen(true); };
const handleCloseDialog = () => { setViewDialogOpen(false); setSelectedItem(null); setShowAllUpdates(false); };
  const handleAddClick = () => { setEditIndex(null); clear(); setIsDialogOpen(true); };
const handleEditClick = (item: any) => {
  setClearProvider(false);
  setClearDoctor(false);
  setClearNetworks(false);
  setClearInsuranceplan(false);
  setClearPatient(false);
  setClearPolicy(false);
  setClearVip(false);
  setClearSpecialty(false);
  handleEdit(item);
  setIsDialogOpen(true);
};

  // â”€â”€ build payload â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const buildPayload = () => {
    const flat = flattenByType(activitiesByType);
    return {
      relation_name: relationName,
      activity_type: flat.map((c) => c.type.toLowerCase()),
      activity_code: flat.map((c) => c.code),
      activity_types: flat.map((c) => ({ code: c.code, type: c.type })),
      custom_groups: customActivityGroups.map((o) => o.value),
      medical_groups: medicalActivityGroups.map((o) => o.value),
      provider: provider.map(buildProviderValues),
      provider_mode: cardToMode(providerMode),
      provider_all: selectAllProviders,
network: networks.map((o) => o.value),
      network_mode: cardToMode(networkMode),
      network_all: selectAllNetworks,
      insuranceplan: insuranceplan.map((o) => o.value),
      insuranceplan_mode: cardToMode(insuranceMode),
      insuranceplan_all: selectAllInsurance,
      payer: Payer,
      payer_mode: cardToMode(payerMode),
      payer_all: selectAllPayer,
      patient: patients.map((o) => o.label),
      patient_mode: cardToMode(patientMode),
      patient_all: selectAllPatients,
      policy: policy.map(buildPolicyValues),
      policy_mode: cardToMode(policyMode),
      policy_all: selectAllPolicy,
      user_level: userLevel,
      user_mode: cardToMode(userMode),
      user_all: selectAllUser,
      vip: vip.map((o) => o.value),
      vip_mode: cardToMode(vipMode),
      vip_all: selectAllVip,
      doctor: doctor.map((o) => o.label),
      doctor_mode: cardToMode(doctorMode),
      doctor_all: selectAllDoctor,
      specialty: specialty.map((o) => o.value),
      specialty_mode: cardToMode(specialtyMode),
      specialty_all: selectAllSpecialty,
      is_active: isActive,
    };
  };

  const buildProviderValues = (o: any) => {
    if (o.providerId && o.providerName) return { Provider_id: o.providerId, Provider_name: o.providerName };
    const match = o.label?.match(/^\((.+)\) (.+)$/);
    if (match) return { Provider_id: match[1].trim(), Provider_name: match[2].trim() };
    return { Provider_id: o.value?.toString() || "", Provider_name: o.label?.toString() || "" };
  };

  const buildPolicyValues = (p: any) => {
    if (typeof p === "object" && p.Policy_id && !p.value) return { id: p.id || 0, Policy_id: p.Policy_id, Policy_name: p.Policy_name, plans: p.plans || [] };
    if (typeof p === "object" && p.value) return { id: p.value.id || 0, Policy_id: p.value.Policy_id || "", Policy_name: p.value.Policy_name || "", plans: p.value.plans || [] };
    if (typeof p === "string") return { id: 0, Policy_id: p, Policy_name: p, plans: [] };
    return { id: 0, Policy_id: "", Policy_name: "", plans: [] };
  };

  // â”€â”€ CRUD â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const addItem = async (): Promise<void> => {
    if (!relationName.trim()) { toast({ title: "Error", description: "Relation Name is required.", variant: "destructive" }); return; }
    if (relationName.trim().length < 3) { toast({ title: "Error", description: "Relation Name must be at least 3 characters.", variant: "destructive" }); return; }
    const entityError = validateEntities();
    if (entityError) {
      toast({ title: "Validation Error", description: entityError, variant: "destructive" });
      return;
    }
    try {
      const response = await ActivitiesReqirePreApprovalsAxiosInstance.post("addNewActivityPreApproved", { data: [buildPayload()], token });
      if (response.data.success) {
 await fetchItems();
  setCurrentPage(0);
  clear(); setIsDialogOpen(false);
          toast({ title: "Success", description: "New rule Added Successfully." });
      } else {
        const errors = response.data.errors || [];
        toast({ title: "Error", description: errors.map((e: any) => e.error).join("\n") || "Failed to add.", variant: "destructive" });
      }
    } catch (error: AxiosError | any) {
      toast({ title: "Error", description: error.response?.data?.error || "An unexpected error occurred.", variant: "destructive" });
    }
  };

  const updateItem = async (id: string | number): Promise<void> => {
    if (!relationName.trim()) { toast({ title: "Error", description: "Relation Name is required.", variant: "destructive" }); return; }
    if (relationName.trim().length < 3) { toast({ title: "Error", description: "Relation Name must be at least 3 characters.", variant: "destructive" }); return; }
    const entityError = validateEntities();
    if (entityError) {
      toast({ title: "Validation Error", description: entityError, variant: "destructive" });
      return;
    }
    try {
      const response = await ActivitiesReqirePreApprovalsAxiosInstance.put("updateActivityPreApproved", { data: { ...buildPayload(), id }, token });
      if (response.data.success) {
       await fetchItems();
  setCurrentPage(0);
  clear(); setIsDialogOpen(false);
        toast({ title: "Success", description: "Rule updated successfully." });
      }
    } catch (error: AxiosError | any) {
      toast({ title: "Error", description: error.response?.data?.error || "An unexpected error occurred.", variant: "destructive" });
    }
  };

  // â”€â”€ handleEdit â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const handleEdit = (item: any) => {
    const n = normalizeItem(item);
    setRelationName(n.relation_name);
    setIsActive(n.is_active);

    // Activity
    const flat: CodeWithType[] = n.activity_types || [];
    if (flat.length > 0) { setActivitiesByType(groupByType(flat)); setSelectedMainOption("list_of_Activity_code"); }
    else { setActivitiesByType({ ...EMPTY_BY_TYPE }); }

    const customData = Array.isArray(n.custom_groups) ? n.custom_groups.map((o: any) => typeof o === "string" ? { id: 0, name: o } : o) : [];
    setCustomActivityGroups(customData.map((o: any) => ({ value: o.id, label: o.name })));
    if (customData.length > 0 && flat.length === 0) setSelectedMainOption("custom_Activity_groups");

    const medicalData = Array.isArray(n.medical_groups) ? n.medical_groups.map((o: any) => typeof o === "string" ? { id: 0, name: o } : o) : [];
    setMedicalActivityGroups(medicalData.map((o: any) => ({ value: o.id, label: o.name })));
    if (medicalData.length > 0 && flat.length === 0 && customData.length === 0) setSelectedMainOption("medical_Activity_groups");
    if (flat.length > 0) setSelectedMainOption("list_of_Activity_code");

    // Provider
    const mappedProviders = (Array.isArray(n.provider) ? n.provider.map((o: any) => typeof o === "string" ? { Provider_id: 0, Provider_name: o } : o) : []).map((o: any) => ({ value: o.Provider_id, label: o.Provider_name }));
    setProvider(mappedProviders);
    const pMode = modeToCard(n.provider_mode);
    setProviderMode(pMode);
    // FIX #1: include selectAll flag in isActive check
    setIsProviderActive(pMode !== null || mappedProviders.length > 0 || (n.provider_all ?? false));
    setSelectAllProviders(n.provider_all ?? false);

    // Doctor
    const mappedDoctors = (Array.isArray(n.doctor) ? n.doctor.map((o: any) => typeof o === "string" ? { Doctor_id: 0, Doctor_name: o } : o) : []).map((o: any) => ({ value: o.Doctor_id, label: o.Doctor_name }));
    setDoctor(mappedDoctors);
    const dMode = modeToCard(n.doctor_mode);
    setDoctorMode(dMode);
    setIsDoctorActive(dMode !== null || mappedDoctors.length > 0 || (n.doctor_all ?? false));
    setSelectAllDoctor(n.doctor_all ?? false);

    // Networks â€” backend key is "network" (singular)
    const mappedNetworks = (Array.isArray(n.network) ? n.network.map((o: any) => typeof o === "string" ? { id: 0, network_name: o } : o) : []).map((o: any) => ({ value: o.id, label: o.network_name }));
    setNetworks(mappedNetworks);
    const nMode = modeToCard(n.network_mode);
    setNetworkMode(nMode);
    setIsNetworkActive(nMode !== null || mappedNetworks.length > 0 || (n.network_all ?? false));
    setSelectAllNetworks(n.network_all ?? false);

    // Insurance
    const mappedInsurance = (Array.isArray(n.insuranceplan) ? n.insuranceplan.map((o: any) => typeof o === "string" ? { id: 0, Plan_name: o } : o) : []).map((o: any) => ({ value: o.id, label: o.Plan_name }));
    setInsuranceplan(mappedInsurance);
    const iMode = modeToCard(n.insuranceplan_mode);
    setInsuranceMode(iMode);
    setIsInsuranceActive(iMode !== null || mappedInsurance.length > 0 || (n.insuranceplan_all ?? false));
    setSelectAllInsurance(n.insuranceplan_all ?? false);

    // Payer
    setPayer(n.payer || []);
    const payMode = modeToCard(n.payer_mode);
    setPayerMode(payMode);
    setIsPayerActive(payMode !== null || (n.payer?.length > 0) || (n.payer_all ?? false));
    setSelectAllPayer(n.payer_all ?? false);

    // Policy
    const mappedPolicy = Array.isArray(n.policy) ? n.policy.map((o: any) => ({ id: o.id || 0, Policy_id: o.Policy_id || "", Policy_name: o.Policy_name || "", plans: o.plans || [] })) : [];
    setPolicy(mappedPolicy);
    const polMode = modeToCard(n.policy_mode);
    setPolicyMode(polMode);
    setIsPolicyActive(polMode !== null || mappedPolicy.length > 0 || (n.policy_all ?? false));
    setSelectAllPolicy(n.policy_all ?? false);

    // Patients â€” backend key is "patient" (singular)
    const mappedPatients = (Array.isArray(n.patient) ? n.patient.map((o: any) => typeof o === "string" ? { id: 0, name: o } : o) : []).map((o: any) => ({ value: o.id, label: o.name }));
    setPatients(mappedPatients);
    const patMode = modeToCard(n.patient_mode);
    setPatientMode(patMode);
    setIsPatientActive(patMode !== null || mappedPatients.length > 0 || (n.patient_all ?? false));
    setSelectAllPatients(n.patient_all ?? false);

    // VIP
    const mappedVip = (Array.isArray(n.vip) ? n.vip.map((o: any) => typeof o === "string" ? { id: 0, name: o } : o) : []).map((o: any) => ({ value: o.id, label: o.name }));
    setVip(mappedVip);
    const vMode = modeToCard(n.vip_mode);
    setVipMode(vMode);
    setIsVipActive(vMode !== null || mappedVip.length > 0 || (n.vip_all ?? false));
    setSelectAllVip(n.vip_all ?? false);

    // User Level
    setUserLevel(n.user_level || []);
    const uMode = modeToCard(n.user_mode);
    setUserMode(uMode);
    setIsUserActive(uMode !== null || (n.user_level?.length > 0) || (n.user_all ?? false));
    setSelectAllUser(n.user_all ?? false);

    // Specialty
    const specialtyData = Array.isArray(n.specialty) ? n.specialty.map((o: any) => typeof o === "string" ? { id: 0, name: o } : o) : [];
    const mappedSpecialty = specialtyData.map((o: any) => ({ value: o.id, label: o.name }));
    setSpecialty(mappedSpecialty);
    const spMode = modeToCard(n.specialty_mode);
    setSpecialtyMode(spMode);
    setIsSpecialtyActive(spMode !== null || mappedSpecialty.length > 0 || (n.specialty_all ?? false));
    setSelectAllSpecialty(n.specialty_all ?? false);

    setEditIndex(n.id);

    // FIX #1: include all selectAll flags so hasEntities is correct
    const hasEntities = !!(
      mappedProviders.length > 0   || (n.provider_all ?? false)      ||
      mappedDoctors.length > 0     || (n.doctor_all ?? false)        ||
      mappedNetworks.length > 0    || (n.network_all ?? false)       ||
      mappedInsurance.length > 0   || (n.insuranceplan_all ?? false) ||
      mappedPolicy.length > 0      || (n.policy_all ?? false)        ||
      mappedPatients.length > 0    || (n.patient_all ?? false)       ||
      mappedVip.length > 0         || (n.vip_all ?? false)           ||
      n.payer?.length > 0          || (n.payer_all ?? false)         ||
      n.user_level?.length > 0     || (n.user_all ?? false)          ||
      mappedSpecialty.length > 0   || (n.specialty_all ?? false)     ||
      (n.provider_mode      && n.provider_mode      !== "DISABLED")  ||
      (n.doctor_mode        && n.doctor_mode        !== "DISABLED")  ||
      (n.network_mode       && n.network_mode       !== "DISABLED")  ||
      (n.insuranceplan_mode && n.insuranceplan_mode !== "DISABLED")  ||
      (n.payer_mode         && n.payer_mode         !== "DISABLED")  ||
      (n.policy_mode        && n.policy_mode        !== "DISABLED")  ||
      (n.patient_mode       && n.patient_mode       !== "DISABLED")  ||
      (n.vip_mode           && n.vip_mode           !== "DISABLED")  ||
      (n.user_mode          && n.user_mode          !== "DISABLED")  ||
      (n.specialty_mode     && n.specialty_mode     !== "DISABLED")
    );
    setShowEntities(hasEntities);
  };

  // â”€â”€ toggleActiveStatus â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const toggleActiveStatus = async (item: any) => {
    try {
      const flat: CodeWithType[] = item.activity_types || [];
      const payload = {
        data: {
          relation_name: item.relation_name,
          is_active: !item.is_active,
          activity_type: flat.map((c) => c.type.toLowerCase()),
          activity_code: flat.map((c) => c.code),
          activity_types: flat,
          custom_groups: (item.custom_groups || []).map((g: any) => g.id ?? g),
          medical_groups: (item.medical_groups || []).map((g: any) => g.id ?? g),
          provider: (item.provider || []).map((o: any) => ({ Provider_id: o.Provider_id || "", Provider_name: o.Provider_name || "" })),
          provider_mode: item.provider_mode ?? "DISABLED",
          provider_all: item.provider_all ?? false,
network: (item.network || []).map((n: any) => n.id ?? n),
          network_mode: item.network_mode ?? "DISABLED",
          network_all: item.network_all ?? false,
          insuranceplan: (item.insuranceplan || []).map((i: any) => i.id ?? i),
          insuranceplan_mode: item.insuranceplan_mode ?? "DISABLED",
          insuranceplan_all: item.insuranceplan_all ?? false,
          payer: item.payer || [],
          payer_mode: item.payer_mode ?? "DISABLED",
          payer_all: item.payer_all ?? false,
patient: (item.patient || []).map((p: any) => p.name ?? p),
          patient_mode: item.patient_mode ?? "DISABLED",
          patient_all: item.patient_all ?? false,
          policy: (item.policy || []).map(buildPolicyValues),
          policy_mode: item.policy_mode ?? "DISABLED",
          policy_all: item.policy_all ?? false,
          user_level: item.user_level || [],
          user_mode: item.user_mode ?? "DISABLED",
          user_all: item.user_all ?? false,
          vip: (item.vip || []).map((v: any) => v.id ?? v),
          vip_mode: item.vip_mode ?? "DISABLED",
          vip_all: item.vip_all ?? false,
          doctor: (item.doctor || []).map((d: any) => d.Doctor_name ?? d),
          doctor_mode: item.doctor_mode ?? "DISABLED",
          doctor_all: item.doctor_all ?? false,
          specialty: (item.specialty || []).map((s: any) => s.id ?? s),
          specialty_mode: item.specialty_mode ?? "DISABLED",
          specialty_all: item.specialty_all ?? false,
          id: item.id,
        },
        token,
      };
      const response = await ActivitiesReqirePreApprovalsAxiosInstance.put("updateActivityPreApproved", payload);
      if (response.data.success) {
        setItems((prev) => ({ data: prev.data.map((i) => i.id === item.id ? { ...i, is_active: !item.is_active } : i) }));
        toast({ title: "Success", description: `Status changed to ${!item.is_active ? "Active" : "Inactive"}.` });
      }
    } catch (error: any) {
      toast({ title: "Error", description: error.response?.data?.error || "An unexpected error occurred.", variant: "destructive" });
    }
  };

const removeItem = async (id: string | number): Promise<void> => {
  try {
    const response = await ActivitiesReqirePreApprovalsAxiosInstance.delete(
      `softDeleteActivityPreApproved/${id}`, { data: { token } }
    );
    if (response.data.success) {
      await fetchItems();
      toast({ title: "Success", description: "Rule Deleted Successfully." });
    } else {
      setForceId(id); setForceAction("softDelete");
      setForceError(response.data.error || "This record is used elsewhere.");
      setForceDialogOpen(true);
    }
  } catch (error: any) {
    const errMsg = error.response?.data?.error || "Failed to delete";
    if (error.response?.status === 409 || errMsg.toLowerCase().includes("used") || errMsg.toLowerCase().includes("referenced")) {
      setForceId(id); setForceAction("softDelete"); setForceError(errMsg); setForceDialogOpen(true);
    } else {
      toast({ title: "Error", description: errMsg, variant: "destructive" });
    }
  }
};

const restoreItem = async (id: string | number): Promise<void> => {
  try {
    const response = await ActivitiesReqirePreApprovalsAxiosInstance.patch(
      `restoreActivityPreApproved/${id}`, { token }
    );
    if (response.data.success) {
      await fetchItems();
      toast({ title: "Success", description: "Rule restored successfully." });
    } else {
      toast({ title: "Error", description: response.data.error || "Failed to restore", variant: "destructive" });
    }
  } catch (error: any) {
    toast({ title: "Error", description: error.response?.data?.error || "Failed to restore", variant: "destructive" });
  }
};

const permanentDeleteItem = async (id: string | number, force = false): Promise<void> => {
  try {
    const url = force ? `deleteActivityPreApproved/${id}?force=true` : `deleteActivityPreApproved/${id}`;
    const response = await ActivitiesReqirePreApprovalsAxiosInstance.delete(url, { data: { token } });
    if (response.data.success) {
      await fetchItems();
      setForceDialogOpen(false); setForceId(null); setForceError(""); setForceAction(null);
      toast({ title: "Success", description: "Rule Permanently Deleted." });
    } else {
      setForceAction("hardDelete");
      setForceError(response.data.error || "This record is used elsewhere.");
    }
  } catch (error: any) {
    setForceAction("hardDelete");
    setForceError(error.response?.data?.error || "Failed to delete");
  }
};

const forceSoftDelete = async (id: string | number): Promise<void> => {
  try {
    const response = await ActivitiesReqirePreApprovalsAxiosInstance.delete(
      `softDeleteActivityPreApproved/${id}?force=true`, { data: { token } }
    );
    if (response.data.success) {
      await fetchItems();
      setForceDialogOpen(false); setForceId(null); setForceError(""); setForceAction(null);
      toast({ title: "Success", description: "Rule force Deleted Successfully." });
    } else {
      setForceError(response.data.error || "Failed to force delete");
    }
  } catch (error: any) {
    setForceError(error.response?.data?.error || "Failed to force delete");
  }
};

  const handleDownload = (item: any) => {
    const flat: CodeWithType[] = item.activity_types || [];
    const rows = ["relation_name;activity_code;activity_type;medical_groups;custom_groups;provider;provider_mode;provider_all;network;network_mode;network_all;insuranceplan;insuranceplan_mode;insuranceplan_all;payer;payer_mode;payer_all;patient;patient_mode;patient_all;policy;policy_mode;policy_all;user_level;user_mode;user_all;doctor;doctor_mode;doctor_all;vip;vip_mode;vip_all;specialty;specialty_mode;specialty_all;is_active"];
    const providers = item.provider || [], nets = item.network || [], insplans = item.insuranceplan || [];
    const pats = item.patient || [], pols = item.policy || [], uls = item.user_level || [];
    const docs = item.doctor || [], pays = item.payer || [], vips = item.vip || [];
    const custom = item.custom_groups || [], medical = item.medical_groups || [];
    const specs = item.specialty || [];
    const maxLen = Math.max(flat.length, custom.length, medical.length, providers.length, nets.length, insplans.length, pats.length, pols.length, uls.length, docs.length, pays.length, vips.length, specs.length, 1);
    for (let i = 0; i < maxLen; i++) {
      rows.push([
        item.relation_name || "",
        i < flat.length ? flat[i].code : "",
        i < flat.length ? flat[i].type : "",
        i < medical.length ? (medical[i] as any).name || "" : "",
        i < custom.length ? (custom[i] as any).name || "" : "",
        i < providers.length ? (providers[i] as any).Provider_name || "" : "",
        item.provider_mode ?? "DISABLED", item.provider_all ? "true" : "false",
        i < nets.length ? (nets[i] as any).network_name || "" : "",
        item.network_mode ?? "DISABLED", item.network_all ? "true" : "false",
        i < insplans.length ? (insplans[i] as any).Plan_name || "" : "",
        item.insuranceplan_mode ?? "DISABLED", item.insuranceplan_all ? "true" : "false",
        i < pays.length ? pays[i] : "",
        item.payer_mode ?? "DISABLED", item.payer_all ? "true" : "false",
        i < pats.length ? (pats[i] as any).name || "" : "",
        item.patient_mode ?? "DISABLED", item.patient_all ? "true" : "false",
        i < pols.length ? (pols[i] as any).Policy_name || "" : "",
        item.policy_mode ?? "DISABLED", item.policy_all ? "true" : "false",
        i < uls.length ? uls[i] : "",
        item.user_mode ?? "DISABLED", item.user_all ? "true" : "false",
        i < docs.length ? (docs[i] as any).Doctor_name || "" : "",
        item.doctor_mode ?? "DISABLED", item.doctor_all ? "true" : "false",
        i < vips.length ? (vips[i] as any).name || "" : "",
        item.vip_mode ?? "DISABLED", item.vip_all ? "true" : "false",
        i < specs.length ? (specs[i] as any).name || "" : "",
        item.specialty_mode ?? "DISABLED", item.specialty_all ? "true" : "false",
        item.is_active ? "TRUE" : "FALSE",
      ].join(";"));
    }
    const blob = new Blob([rows.join("\n")], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `ActivityPreApproved${item.id}.csv`; a.click();
    window.URL.revokeObjectURL(url);
  };

  // â”€â”€ Columns â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const columns: ColumnDef<any>[] = [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <Button variant="ghost" className="w-full justify-center" onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}>
          ID {column.getIsSorted() === "asc" ? "â†‘" : column.getIsSorted() === "desc" ? "â†“" : ""}
        </Button>
      ),
    cell: ({ row }) => (
  <div className="w-full flex justify-center font-medium">{row.index + 1}</div>
),
    },
    {
      accessorKey: "relation_name",
      header: ({ column }) => (
        <Button variant="ghost" className="w-full justify-center" onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}>
          Relation Name {column.getIsSorted() === "asc" ? "â†‘" : column.getIsSorted() === "desc" ? "â†“" : ""}
        </Button>
      ),
cell: ({ row }) => {
  const isDeleted = (row.original as any).is_deleted;
  return (
    <div className={`w-full text-center ${isDeleted ? "line-through text-gray-400" : ""}`}>
      {row.getValue("relation_name")}
    </div>
  );
},
    },
    {
      accessorKey: "activity_code",
      header: ({ column }) => (
        <Button variant="ghost" className="w-full justify-center" onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}>
          Activity Code {column.getIsSorted() === "asc" ? "â†‘" : column.getIsSorted() === "desc" ? "â†“" : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const item = row.original;
        const actTypes: CodeWithType[] = item.activity_types || [];
        const custom = Array.isArray(item.custom_groups) ? item.custom_groups.map((g: any) => g.name || g) : [];
        const medical = Array.isArray(item.medical_groups) ? item.medical_groups.map((g: any) => g.name || g) : [];
        const groups = [...medical.map((g: string) => `[Medical] ${g}`), ...custom.map((g: string) => `[Custom] ${g}`)];
        return (
          <ActivityTypeCell
            items={actTypes}
            groups={groups}
            searchTerm={filterSearch}
            onShowAll={(its, grps) => { setAllCodesItems(its); setAllCodesGroups(grps); setAllCodesTitle(`${item.relation_name} â€“ Activity Codes`); setAllCodesOpen(true); }}
          />
        );
      },
    },
    {
      accessorKey: "is_active",
      enableSorting: false,
      header: () => <div className="w-full text-center font-normal">Status</div>,
    cell: ({ row }) => {
  const item = row.original;
  const isDeleted = (item as any).is_deleted;
  return (
    <div className="w-full flex justify-center">
      <button
        onClick={() => !isDeleted && toggleActiveStatus(item)}
        disabled={!!isDeleted}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
          isDeleted ? "opacity-40 cursor-not-allowed bg-gray-200"
          : item.is_active ? "bg-green-500" : "bg-gray-300"
        }`}>
        <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
          item.is_active && !isDeleted ? "translate-x-6" : "translate-x-1"
        }`} />
      </button>
    </div>
  );
},
    },
    {
      id: "view",
      header: () => <div className="w-full text-center font-normal">View</div>,
      cell: ({ row }) => (
        <div className="w-full flex justify-center py-2">
          <button onClick={() => handleOpenDialog(row.original)} className="text-blue-600 hover:text-blue-800" title="View Details">
            <i className="fa-solid fa-eye text-lg" />
          </button>
        </div>
      ),
    },
  ];

  // â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  return (
    <div className="h5-container mx-auto px-1 pt-16 pb-4" data-qa-page="activity-pre-approvals">
      <div className="flex justify-between items-center mb-6">
        <h5 className="flex items-center gap-3 font-bold text-2xl text-blue-900 mt-8">
          <span className="flex items-center justify-center w-10 h-10 rounded-full bg-blue-900 text-white">
            <i className="fa-solid fa-check-circle" />
          </span>
          Activity Pre-Approvals
        </h5>
      </div>

      <DataTable2
        qaIdPrefix="activity-pre-approvals-data-table"
        columns={columns}
        data={items.data}
        searchColumns={[]}
        addButtonLabel="Add New Relation"
        validateButtonLabel="Validate"
        showAddButton={false}
        pageIndex={currentPage}
        onPageChange={setCurrentPage}
        manualPagination={manualPagination}
        pageCount={totalPages}
        totalCount={totalCount}
        pageSize={pageSize}
        onPageSizeChange={(nextPageSize) => {
          setPageSize(nextPageSize);
          setCurrentPage(0);
        }}
        allowedPageSizes={allowedPageSizes}
        isLoading={isTableLoading}
        onEdit={handleEdit}
onDelete={(id) => {
  const item = items.data.find(i => i.id === id);
  if ((item as any)?.is_deleted) {
    setForceId(id); setForceAction("hardDelete"); setForceError(""); setForceDialogOpen(true);
  } else {
    removeItem(id);
  }
}}
onRestore={canManageDeleted ? restoreItem : undefined}
canHardDelete={canManageDeleted}
isRowDeleted={(row: any) => row.is_deleted === true}
        onAdd={handleAddClick}
        onEditClick={handleEditClick}
        onDownload={handleDownload}
        toolbarExtras={
          <div style={{ width: "100%", position: "relative" }}>
<div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", padding: "10px 160px 10px 16px", background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)", borderRadius: 12, border: "1px solid #e2e8f0", boxShadow: "0 1px 3px rgba(0,0,0,0.04)", marginBottom: 12 }}>
  <ServerDeletedPills
    value={deletedFilter}
    onChange={(value) => { setDeletedFilter(value); setCurrentPage(0); }}
    />
              <button type="button" onClick={handleAddClick} style={{ display: "flex", alignItems: "center", gap: 7, padding: "8px 18px", fontSize: 13, fontWeight: 600, color: "#ffffff", background: "#1e3a8a", border: "none", borderRadius: 8, cursor: "pointer", whiteSpace: "nowrap", boxShadow: "0 2px 6px rgba(30,58,138,0.25)" }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M12 5v14M5 12h14" /></svg>
                Add New Relation
              </button>
              <div style={{ width: 1, height: 28, background: "#cbd5e1" }} />
              <UnifiedSearchBox
                value={filterSearch}
                onChange={(value) => { setFilterSearch(value); setCurrentPage(0); }}
                helpText="Relation Name, Activity Code, Medical Group, or Custom Group."
              />
              <div style={{ width: 1, height: 28, background: "#cbd5e1" }} />
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontSize: 11, fontWeight: 600, color: "#64748b", letterSpacing: "0.05em" }}>Status</span>
                <div style={{ display: "flex", alignItems: "center", padding: 4, background: "#e2e8f0", borderRadius: 9999 }}>
                  {[{ value: "", label: "All" }, { value: "true", label: "Active" }, { value: "false", label: "Inactive" }].map((opt) => (
                    <button key={opt.value} type="button" onClick={() => setFilterStatus(opt.value)} style={{ display: "flex", alignItems: "center", gap: 6, padding: "6px 14px", fontSize: 13, fontWeight: 500, borderRadius: 9999, border: "none", cursor: "pointer", transition: "all 0.2s ease", background: filterStatus === opt.value ? opt.value === "true" ? "#10b981" : opt.value === "false" ? "#94a3b8" : "#ffffff" : "transparent", color: filterStatus === opt.value ? opt.value === "" ? "#334155" : "#ffffff" : "#64748b", boxShadow: filterStatus === opt.value ? "0 2px 4px rgba(0,0,0,0.1)" : "none" }}>
                      {opt.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
            <div style={{ position: "absolute", top: 0, right: 16, height: 62, display: "flex", alignItems: "center" }}>
              <FileUpload fetchItems={fetchItems} />
            </div>
          </div>
        }
      />

      {/* â•â• VIEW DIALOG â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
      <Dialog open={viewDialogOpen} onOpenChange={(open) => { if (!open) handleCloseDialog(); }}>
        <DialogContent className="max-w-[900px] max-h-[92vh] flex flex-col p-0 overflow-hidden bg-white border-none rounded-2xl" style={{ boxShadow: "0 25px 60px rgba(0,0,0,0.18), 0 0 0 1px rgba(0,0,0,0.04)" }}>
          {selectedItem && (
            <>
              <div style={{ background: "linear-gradient(135deg, #0f172a 0%, #1e3a8a 60%, #2563eb 100%)", padding: "24px 28px 20px", flexShrink: 0, position: "relative", overflow: "hidden" }}>
                <div style={{ position: "absolute", top: -40, right: -40, width: 160, height: 160, borderRadius: "50%", background: "rgba(255,255,255,0.04)" }} />
                <div style={{ position: "absolute", bottom: -30, left: -20, width: 100, height: 100, borderRadius: "50%", background: "rgba(255,255,255,0.03)" }} />
                <div style={{ display: "flex", alignItems: "flex-start", gap: 16, position: "relative", zIndex: 1 }}>
                  <div style={{ width: 48, height: 48, borderRadius: 14, background: "rgba(255,255,255,0.12)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, color: "#fff", flexShrink: 0, border: "1px solid rgba(255,255,255,0.1)" }}>
                    <i className="fa-solid fa-file-shield" />
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 2 }}>
                      <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", margin: 0 }}>{selectedItem.relation_name}</h2>
                      <span style={{ display: "inline-flex", alignItems: "center", gap: 5, padding: "3px 12px", borderRadius: 9999, fontSize: 11, fontWeight: 600, flexShrink: 0, background: selectedItem.is_active ? "rgba(34,197,94,0.2)" : "rgba(239,68,68,0.15)", color: selectedItem.is_active ? "#86efac" : "#fca5a5", border: `1px solid ${selectedItem.is_active ? "rgba(34,197,94,0.25)" : "rgba(239,68,68,0.2)"}` }}>
                        <span style={{ width: 6, height: 6, borderRadius: "50%", background: "currentColor" }} />
                        {selectedItem.is_active ? "Active" : "Inactive"}
                      </span>
                    </div>
                    <p style={{ fontSize: 12, color: "rgba(147,197,253,0.8)", margin: 0 }}>Rule ID: <span style={{ fontWeight: 600, color: "#93c5fd" }}>#{selectedItem.id}</span></p>
                  </div>
                </div>
              </div>
              <div style={{ overflowY: "auto", flex: 1, background: "#f8fafc", padding: "20px 28px" }}>
                {/* Activity Codes */}
           {/* Activity Codes + Groups */}
<div style={{ marginBottom: 20 }}>
  <span style={{ fontSize: 13, fontWeight: 700, color: "#0f172a" }}>Activity Configuration</span>
  {(() => {
    const flat: CodeWithType[] = selectedItem.activity_types || [];
    const grouped: Record<string, string[]> = { CPT: [], HCPCS: [], Dental: [], Drugs: [] };
    flat.forEach(({ code, type }) => { if (grouped[type]) grouped[type].push(code); });

    const medical = Array.isArray(selectedItem.medical_groups)
      ? selectedItem.medical_groups.map((g: any) => (typeof g === "string" ? g : g?.name)).filter(Boolean)
      : [];
    const custom = Array.isArray(selectedItem.custom_groups)
      ? selectedItem.custom_groups.map((g: any) => (typeof g === "string" ? g : g?.name)).filter(Boolean)
      : [];

    const hasCodes = flat.length > 0;
    const hasGroups = medical.length > 0 || custom.length > 0;

    if (!hasCodes && !hasGroups)
      return <p style={{ fontSize: 12, color: "#cbd5e1", fontStyle: "italic", marginTop: 12 }}>No activity configured</p>;

    return (
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginTop: 12 }}>
        {Object.entries(grouped).map(([type, codes]) => codes.length === 0 ? null : (
          <div key={type} style={{ background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", padding: "14px 16px" }}>
            <div style={{ fontSize: 11, fontWeight: 600, color: "#64748b", marginBottom: 8 }}>{type} Codes ({codes.length})</div>
            <div style={{ display: "flex", flexWrap: "wrap" as const, gap: 5 }}>
              {codes.map((code, i) => <span key={i} style={{ padding: "3px 10px", borderRadius: 9999, fontSize: 11, fontWeight: 500, background: "#eff6ff", color: "#1d4ed8", border: "0.5px solid #bfdbfe" }}>{code}</span>)}
            </div>
          </div>
        ))}

        {medical.length > 0 && (
          <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", padding: "14px 16px" }}>
            <div style={{ fontSize: 11, fontWeight: 600, color: "#64748b", marginBottom: 8 }}>Medical Groups ({medical.length})</div>
            <div style={{ display: "flex", flexWrap: "wrap" as const, gap: 5 }}>
              {medical.map((g: string, i: number) => <span key={i} style={{ padding: "3px 10px", borderRadius: 9999, fontSize: 11, fontWeight: 500, background: "#f0fdf4", color: "#15803d", border: "0.5px solid #bbf7d0" }}>{g}</span>)}
            </div>
          </div>
        )}

        {custom.length > 0 && (
          <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", padding: "14px 16px" }}>
            <div style={{ fontSize: 11, fontWeight: 600, color: "#64748b", marginBottom: 8 }}>Custom Groups ({custom.length})</div>
            <div style={{ display: "flex", flexWrap: "wrap" as const, gap: 5 }}>
              {custom.map((g: string, i: number) => <span key={i} style={{ padding: "3px 10px", borderRadius: 9999, fontSize: 11, fontWeight: 500, background: "#faf5ff", color: "#7e22ce", border: "0.5px solid #e9d5ff" }}>{g}</span>)}
            </div>
          </div>
        )}
      </div>
    );
  })()}
</div>
                {/* Entities */}
                <div style={{ height: 1, background: "#e2e8f0", marginBottom: 20 }} />
                <span style={{ fontSize: 13, fontWeight: 700, color: "#0f172a" }}>Target Scope</span>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginTop: 12 }}>
                  {[
                 { label: "Providers", icon: "fa-hospital", color: "#3b82f6", items: (selectedItem.provider || []).map((p: any) => p.Provider_name || String(p)), mode: selectedItem.provider_mode, all: selectedItem.provider_all },
                    { label: "Doctors", icon: "fa-stethoscope", color: "#06b6d4", items: (selectedItem.doctor || []).map((d: any) => d.Doctor_name || String(d)), mode: selectedItem.doctor_mode, all: selectedItem.doctor_all },
                    { label: "Networks", icon: "fa-network-wired", color: "#8b5cf6", items: (selectedItem.networks ?? (selectedItem as any).network ?? []).map((n: any) => n.network_name || String(n)), mode: selectedItem.network_mode, all: selectedItem.network_all },
                    { label: "Insurance Plans", icon: "fa-shield-halved", color: "#f59e0b", items: (selectedItem.insuranceplan || []).map((i: any) => i.Plan_name || String(i)), mode: selectedItem.insuranceplan_mode, all: selectedItem.insuranceplan_all },
                    { label: "Policies", icon: "fa-file-lines", color: "#10b981", items: (selectedItem.policy || []).map((p: any) => `${p.Policy_id || ""} - ${p.Policy_name || ""}`), mode: selectedItem.policy_mode, all: selectedItem.policy_all },
                    { label: "Patients", icon: "fa-users", color: "#ec4899", items: (selectedItem.patients ?? (selectedItem as any).patient ?? []).map((p: any) => p.name || String(p)), mode: selectedItem.patient_mode, all: selectedItem.patient_all },
                    { label: "VIP", icon: "fa-star", color: "#eab308", items: (selectedItem.vip || []).map((v: any) => v.name || String(v)), mode: selectedItem.vip_mode, all: selectedItem.vip_all },
                    { label: "Payer", icon: "fa-building-columns", color: "#6366f1", items: (selectedItem.payer || []).map((p: any) => String(p)), mode: selectedItem.payer_mode, all: selectedItem.payer_all },
                    { label: "User Levels", icon: "fa-user-gear", color: "#64748b", items: (selectedItem.user_level || []).map((u: any) => String(u)), mode: selectedItem.user_mode, all: selectedItem.user_all },
                    { label: "Specialty", icon: "fa-briefcase-medical", color: "#0d9488", items: (selectedItem.specialty || []).map((s: any) => s.name || String(s)), mode: selectedItem.specialty_mode, all: selectedItem.specialty_all },
                  ].map((e) => {
                  const isExclude = e.mode === "EXCLUDED";
                    const isDisabled = !e.mode || e.mode === "DISABLED";
                    const isAll = !!e.all;
                    return (
                      <div key={e.label} style={{ background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", padding: "14px 16px" }}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
                            <i className={`fa-solid ${e.icon}`} style={{ fontSize: 11, color: e.color }} />
                            <span style={{ fontSize: 12, fontWeight: 600, color: "#334155" }}>{e.label}</span>
                          </div>
                          {!isDisabled && (
                            <span style={{ fontSize: 10, padding: "2px 8px", borderRadius: 9999, fontWeight: 600, background: isExclude ? "#fef2f2" : "#f0fdf4", color: isExclude ? "#dc2626" : "#15803d", border: `1px solid ${isExclude ? "#fecaca" : "#bbf7d0"}` }}>
                              {isExclude ? "Exclusion" : "Inclusion"}
                            </span>
                          )}
                        </div>
                       {isAll
                          ? <span style={{ fontSize: 11, padding: "3px 10px", borderRadius: 9999, background: "#eff6ff", color: "#1d4ed8", border: "1px solid #bfdbfe", fontWeight: 600, display: "inline-flex", alignItems: "center", gap: 5 }}><i className="fa-solid fa-check-double" style={{ fontSize: 9 }} /> All {e.label}</span>
                          : e.items.length > 0
                            ? <div style={{ display: "flex", flexWrap: "wrap" as const, gap: 5 }}>{e.items.map((item: string, i: number) => <span key={i} style={{ fontSize: 11, padding: "3px 10px", borderRadius: 9999, background: "#f1f5f9", color: "#334155", border: "1px solid #e2e8f0", fontWeight: 500 }}>{item}</span>)}</div>
                            : <span style={{ color: "#cbd5e1", fontSize: 12, fontStyle: "italic" }}>No items</span>}
                      </div>
                    );
                  })}
                </div>
                {/* Audit */}
                <div style={{ height: 1, background: "#e2e8f0", margin: "20px 0" }} />
                <span style={{ fontSize: 13, fontWeight: 700, color: "#0f172a" }}>Audit Trail</span>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginTop: 12 }}>
                  <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", padding: "14px 16px" }}>
                    <span style={{ fontSize: 10, fontWeight: 600, color: "#94a3b8" }}>Created By</span>
                    <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 10 }}>
                      <div style={{ width: 32, height: 32, borderRadius: "50%", background: "linear-gradient(135deg, #3b82f6, #2563eb)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 700, color: "#fff" }}>
                        {String(selectedItem.created_by ?? "?")[0].toUpperCase()}
                      </div>
                      <span style={{ fontSize: 13, fontWeight: 600, color: "#1e293b" }}>{resolveUserName(selectedItem.created_by)}</span>
                    </div>
                  </div>
                  <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", padding: "14px 16px" }}>
                    <span style={{ fontSize: 10, fontWeight: 600, color: "#94a3b8" }}>Created On</span>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 10 }}>
                      <i className="fa-regular fa-calendar" style={{ fontSize: 14, color: "#3b82f6" }} />
                      <span style={{ fontSize: 13, fontWeight: 600, color: "#1e293b" }}>{selectedItem.createdat ? new Date(selectedItem.createdat).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "â€”"}</span>
                    </div>
                  </div>
                  <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", padding: "14px 16px" }}>
                    <span style={{ fontSize: 10, fontWeight: 600, color: "#94a3b8" }}>Last Updated</span>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 10 }}>
                      <i className="fa-regular fa-clock" style={{ fontSize: 14, color: "#10b981" }} />
                      <span style={{ fontSize: 13, fontWeight: 600, color: "#1e293b" }}>{selectedItem.updatedat ? new Date(selectedItem.updatedat).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "â€”"}</span>
                    </div>
                  </div>
                </div>
              </div>
            
              {Array.isArray(selectedItem.updated_by) && selectedItem.updated_by.length > 0 && (
  <div style={{ gridColumn: "1 / -1", background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", padding: "14px 16px", boxShadow: "0 1px 3px rgba(0,0,0,0.03)", marginTop: 12 }}>
    <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 12 }}>
      <i className="fa-solid fa-pen-to-square" style={{ fontSize: 11, color: "#10b981" }} />
      <span style={{ fontSize: 10, fontWeight: 600, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.02em" }}>Update History</span>
      <span style={{ fontSize: 10, padding: "1px 8px", borderRadius: 9999, background: "#f0fdf4", color: "#15803d", fontWeight: 600, border: "1px solid #bbf7d0", marginLeft: "auto" }}>
        {selectedItem.updated_by.length} update{selectedItem.updated_by.length !== 1 ? "s" : ""}
      </span>
    </div>
    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      {(selectedItem.updated_by as { id?: number; at?: string }[]).slice().reverse().slice(0, showAllUpdates ? undefined : 4).map((entry, i) => (
        <div key={i} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", borderRadius: 8, background: i === 0 ? "#f0fdf4" : "#f8fafc", border: `1px solid ${i === 0 ? "#bbf7d0" : "#e2e8f0"}` }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div style={{ width: 28, height: 28, borderRadius: "50%", background: i === 0 ? "linear-gradient(135deg, #10b981, #059669)" : "linear-gradient(135deg, #94a3b8, #64748b)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700, color: "#fff", flexShrink: 0 }}>
              {String(resolveUserName(entry.id) ?? "?")[0].toUpperCase()}
            </div>
            <span style={{ fontSize: 12, fontWeight: 600, color: "#1e293b" }}>{resolveUserName(entry.id)}</span>
            {i === 0 && <span style={{ fontSize: 10, padding: "1px 8px", borderRadius: 9999, background: "#dcfce7", color: "#15803d", fontWeight: 600, border: "1px solid #bbf7d0" }}>Latest</span>}
          </div>
          <span style={{ fontSize: 11, color: "#64748b", fontWeight: 500 }}>
            {entry.at ? new Date(entry.at).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "â€”"}
          </span>
        </div>
      ))}
      {selectedItem.updated_by.length > 4 && (
        <div style={{ textAlign: "center", padding: "6px 0" }}>
          <button onClick={() => setShowAllUpdates(v => !v)} style={{ fontSize: 11, color: "#3b82f6", fontWeight: 600, background: "none", border: "none", cursor: "pointer" }}>
            {showAllUpdates ? "Show less â†‘" : `+${selectedItem.updated_by.length - 4} more updates â†“`}
          </button>
        </div>
      )}
    </div>
  </div>
)}
  <div style={{ padding: "14px 28px", borderTop: "1px solid #e2e8f0", background: "#fff", display: "flex", justifyContent: "flex-end", flexShrink: 0 }}>
                <Button onClick={handleCloseDialog} style={{ background: "linear-gradient(135deg, #1e3a8a, #2563eb)", color: "#fff", fontWeight: 600, padding: "8px 28px", borderRadius: 10 }}>Close Details</Button>
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>

 {/* â•â• ADD / EDIT DIALOG â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent className="max-w-3xl h-[85vh] flex flex-col overflow-hidden p-0">
          <div className="flex-shrink-0 bg-white border-b border-gray-200 px-6 py-4">
            <DialogHeader>
              <DialogTitle className="text-lg font-semibold text-gray-900">
                {editIndex === null ? "Add Activity Pre-Approvals" : "Edit Activity Pre-Approvals"}
              </DialogTitle>
              </DialogHeader>
          </div>

          <div className="flex-1 overflow-y-auto px-6 py-5 space-y-0">
            {/* Section 1: Basic */}
            <SectionCard num={1} title="Basic information" subtitle="Rule name and status">
              <div className="flex items-start gap-4">
                <div className="flex-1">
                  <Label htmlFor="relation_name">Relation name <span className="text-red-500 ml-0.5">*</span></Label>
                  <Input id="relation_name" value={relationName} onChange={(e) => setRelationName(e.target.value)} placeholder="Must be at least 3 characters" className="mt-1" />
                </div>
                <div className="w-48 flex-shrink-0">
                  <Label>Status</Label>
                  <div className="flex gap-2 mt-1">
                    <button type="button" onClick={() => setIsActive(true)} className={`flex-1 h-10 rounded-md text-sm font-medium border transition-all ${isActive ? "bg-green-50 text-green-800 border-green-300" : "bg-white text-gray-400 border-gray-200 hover:bg-gray-100"}`}>Active</button>
                    <button type="button" onClick={() => setIsActive(false)} className={`flex-1 h-10 rounded-md text-sm font-medium border transition-all ${!isActive ? "bg-red-50 text-red-800 border-red-300" : "bg-white text-gray-400 border-gray-200 hover:bg-gray-100"}`}>Inactive</button>
                  </div>
                </div>
              </div>
            </SectionCard>

            {/* Section 2: Activity */}
            <SectionCard num={2} title="Activity configuration" subtitle="Which activity codes or groups require pre-approval">
              <div className="grid grid-cols-3 gap-3 mb-4">
                {[
                  { key: "list_of_Activity_code", label: "Activity Codes", icon: "fa-code", count: activitiesByType.CPT.length + activitiesByType.HCPCS.length + activitiesByType.Dental.length + activitiesByType.Drugs.length },
                  { key: "medical_Activity_groups", label: "Medical Groups", icon: "fa-layer-group", count: medicalActivityGroups.length },
                  { key: "custom_Activity_groups", label: "Custom Groups", icon: "fa-cubes", count: customActivityGroups.length },
                ].map((opt) => {
                  const isSelected = selectedMainOption === opt.key;
                  return (
                    <button
                      key={opt.key}
                      type="button"
                      onClick={() => setSelectedMainOption(isSelected ? null : opt.key)}
                      className={`relative flex flex-col items-center gap-2 rounded-xl border-2 px-3 py-4 transition-all ${isSelected ? "border-blue-500 bg-blue-50 shadow-sm" : "border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50"}`}
                    >
                      {opt.count > 0 && (
                        <span className={`absolute top-2 right-2 text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center ${isSelected ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-500"}`}>
                          {opt.count}
                        </span>
                      )}
                      <span className={`w-9 h-9 rounded-lg flex items-center justify-center ${isSelected ? "bg-blue-500 text-white" : "bg-gray-100 text-gray-400"}`}>
                        <i className={`fa-solid ${opt.icon} text-sm`}></i>
                      </span>
                      <span className={`text-xs font-semibold text-center ${isSelected ? "text-blue-700" : "text-gray-500"}`}>{opt.label}</span>
                    </button>
                  );
                })}
              </div>

              {selectedMainOption === "list_of_Activity_code" && (
                <div className="rounded-lg border border-gray-200 bg-gray-50 p-4 space-y-3">
                  <h3 className="text-sm font-bold text-gray-800 flex items-center gap-2"><i className="fa-solid fa-code text-blue-600" /> Activity Codes by Type</h3>
                  <div className="grid grid-cols-2 gap-3">
                    {(["CPT", "HCPCS", "Dental", "Drugs"] as const).map((key) => {
                      const colMap: Record<string, string> = { CPT: "blue", HCPCS: "green", Dental: "purple", Drugs: "orange" };
                      const c = colMap[key];
                      return (
                        <div key={key} className={`bg-white p-3 rounded-lg border border-${c}-200`}>
                          <Label className="flex items-center gap-2 mb-2">
                            <span className={`px-2 py-0.5 bg-${c}-100 text-${c}-900 rounded text-xs font-bold border border-${c}-400`}>{key}</span>
                            <span className="text-xs text-gray-500">({activitiesByType[key].length} codes)</span>
                          </Label>
                          <ListofActivityCode onChange={(selected: Option[]) => setActivitiesByType(prev => ({ ...prev, [key]: selected }))} type={key} defaultValue={activitiesByType[key]} clear={false} isValid={true} />
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              {selectedMainOption === "medical_Activity_groups" && (
                <div className="rounded-lg border border-gray-200 bg-gray-50 p-4">
                  <ListOfActivityMedical onChange={setMedicalActivityGroups} defaultValue={medicalActivityGroups} clear={false} />
                </div>
              )}
              {selectedMainOption === "custom_Activity_groups" && (
                <div className="rounded-lg border border-gray-200 bg-gray-50 p-4">
                  <ListOfActivityCustom onChange={setCustomActivityGroups} defaultValue={customActivityGroups} clear={false} />
                </div>
              )}
            </SectionCard>

            {/* Section 3: Entities Configuration */}
            <div className="border-2 border-blue-200 rounded-xl overflow-hidden mb-4 shadow-sm">
              <div className="flex items-center justify-between px-5 py-3 bg-blue-50 border-b border-blue-200">
                <div className="flex items-center gap-3">
                  <span className="w-6 h-6 rounded-full bg-blue-700 text-white text-xs font-semibold flex items-center justify-center flex-shrink-0">3</span>
                  <div>
                    <p className="text-sm font-semibold text-blue-900">Entities Configuration</p>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={handleToggleEntities}
                  className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none ${showEntities ? "bg-green-500" : "bg-gray-300"}`}
                >
                  <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${showEntities ? "translate-x-6" : "translate-x-1"}`} />
                </button>
              </div>

              {showEntities && (
                <div className="p-5 bg-blue-50">
                  <div className="flex gap-3 p-3 bg-blue-100 border-l-4 border-blue-500 rounded-r-lg mb-4">
                    <svg className="w-4 h-4 text-blue-700 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
                    <p className="text-xs text-blue-900 leading-relaxed">
                      <span className="font-semibold text-emerald-700">Inclusion</span> = apply only to selected items &nbsp;Â·&nbsp;
                      <span className="font-semibold text-red-700">Exclusion</span> = apply to everyone except selected items
                    </p>
                  </div>

                  <div className="grid grid-cols-2 gap-3">
                    <EntityCard label="Providers" icon="fa-hospital" color="blue" isActive={isProviderActive} mode={providerMode}
                      onExclusion={() => { if (providerMode === "EXCLUSION") { setProvider([]); setClearProvider(true); setSelectAllProviders(false); setProviderMode(null); setIsProviderActive(false); } else { setProvider([]); setClearProvider(true); setSelectAllProviders(false); setProviderMode("EXCLUSION"); setIsProviderActive(true); } }}
                      onInclusion={() => { if (providerMode === "INCLUSION") { setProvider([]); setClearProvider(true); setSelectAllProviders(false); setProviderMode(null); setIsProviderActive(false); } else { setProvider([]); setClearProvider(true); setSelectAllProviders(false); setProviderMode("INCLUSION"); setIsProviderActive(true); } }}
                      onClear={() => { setProvider([]); setProviderMode(null); setIsProviderActive(false); setClearProvider(true); setSelectAllProviders(false); }}>
                      <label className="flex items-center gap-2 cursor-pointer px-1 py-1 rounded-md hover:bg-slate-50 transition-colors">
                        <input type="checkbox" checked={selectAllProviders} onChange={(e) => { const c = e.target.checked; preserveScrollCheckbox(e, () => { setSelectAllProviders(c); if (c) { setProvider([]); setClearProvider(true); } }); }} className="w-4 h-4 rounded border-slate-300 accent-blue-600" />
                        <span className="text-sm font-medium text-slate-600">Select All Providers</span>
                      </label>
                      {!selectAllProviders && <ListOfProviderName onChange={setProvider} defaultValue={provider} clear={clearProvider} />}
                    </EntityCard>

                    <EntityCard label="Doctor" icon="fa-stethoscope" color="cyan" isActive={isDoctorActive} mode={doctorMode}
                      onExclusion={() => { if (doctorMode === "EXCLUSION") { setDoctor([]); setClearDoctor(true); setSelectAllDoctor(false); setDoctorMode(null); setIsDoctorActive(false); } else { setDoctor([]); setClearDoctor(true); setSelectAllDoctor(false); setDoctorMode("EXCLUSION"); setIsDoctorActive(true); } }}
                      onInclusion={() => { if (doctorMode === "INCLUSION") { setDoctor([]); setClearDoctor(true); setSelectAllDoctor(false); setDoctorMode(null); setIsDoctorActive(false); } else { setDoctor([]); setClearDoctor(true); setSelectAllDoctor(false); setDoctorMode("INCLUSION"); setIsDoctorActive(true); } }}
                      onClear={() => { setDoctor([]); setDoctorMode(null); setIsDoctorActive(false); setClearDoctor(true); setSelectAllDoctor(false); }}>
                      <label className="flex items-center gap-2 cursor-pointer px-1 py-1 rounded-md hover:bg-slate-50 transition-colors">
                        <input type="checkbox" checked={selectAllDoctor} onChange={(e) => { const c = e.target.checked; preserveScrollCheckbox(e, () => { setSelectAllDoctor(c); if (c) { setDoctor([]); setClearDoctor(true); } }); }} className="w-4 h-4 rounded border-slate-300 accent-cyan-600" />
                        <span className="text-sm font-medium text-slate-600">Select All Doctors</span>
                      </label>
                      {!selectAllDoctor && <ListOfDoctorName onChange={setDoctor} defaultValue={doctor} clear={clearDoctor} />}
                    </EntityCard>

                    <EntityCard label="Specialty" icon="fa-user-doctor" color="teal" isActive={isSpecialtyActive} mode={specialtyMode}
                      onExclusion={() => { if (specialtyMode === "EXCLUSION") { setSpecialty([]); setClearSpecialty(true); setSelectAllSpecialty(false); setSpecialtyMode(null); setIsSpecialtyActive(false); } else { setSpecialty([]); setClearSpecialty(true); setSelectAllSpecialty(false); setSpecialtyMode("EXCLUSION"); setIsSpecialtyActive(true); } }}
                      onInclusion={() => { if (specialtyMode === "INCLUSION") { setSpecialty([]); setClearSpecialty(true); setSelectAllSpecialty(false); setSpecialtyMode(null); setIsSpecialtyActive(false); } else { setSpecialty([]); setClearSpecialty(true); setSelectAllSpecialty(false); setSpecialtyMode("INCLUSION"); setIsSpecialtyActive(true); } }}
                      onClear={() => { setSpecialty([]); setSpecialtyMode(null); setIsSpecialtyActive(false); setClearSpecialty(true); setSelectAllSpecialty(false); }}>
                      <label className="flex items-center gap-2 cursor-pointer px-1 py-1 rounded-md hover:bg-slate-50 transition-colors">
                        <input type="checkbox" checked={selectAllSpecialty} onChange={(e) => { const c = e.target.checked; preserveScrollCheckbox(e, () => { setSelectAllSpecialty(c); if (c) { setSpecialty([]); setClearSpecialty(true); } }); }} className="w-4 h-4 rounded border-slate-300 accent-teal-600" />
                        <span className="text-sm font-medium text-slate-600">Select All Specialties</span>
                      </label>
                      {!selectAllSpecialty && <ListOfSpecialtyName onChange={setSpecialty} defaultValue={specialty} clear={clearSpecialty} />}
                    </EntityCard>

                    <EntityCard label="Networks" icon="fa-network-wired" color="purple" isActive={isNetworkActive} mode={networkMode}
                      onExclusion={() => { if (networkMode === "EXCLUSION") { setNetworks([]); setClearNetworks(true); setSelectAllNetworks(false); setNetworkMode(null); setIsNetworkActive(false); } else { setNetworks([]); setClearNetworks(true); setSelectAllNetworks(false); setNetworkMode("EXCLUSION"); setIsNetworkActive(true); } }}
                      onInclusion={() => { if (networkMode === "INCLUSION") { setNetworks([]); setClearNetworks(true); setSelectAllNetworks(false); setNetworkMode(null); setIsNetworkActive(false); } else { setNetworks([]); setClearNetworks(true); setSelectAllNetworks(false); setNetworkMode("INCLUSION"); setIsNetworkActive(true); } }}
                      onClear={() => { setNetworks([]); setNetworkMode(null); setIsNetworkActive(false); setClearNetworks(true); setSelectAllNetworks(false); }}>
                      <label className="flex items-center gap-2 cursor-pointer px-1 py-1 rounded-md hover:bg-slate-50 transition-colors">
                        <input type="checkbox" checked={selectAllNetworks} onChange={(e) => { const c = e.target.checked; preserveScrollCheckbox(e, () => { setSelectAllNetworks(c); if (c) { setNetworks([]); setClearNetworks(true); } }); }} className="w-4 h-4 rounded border-slate-300 accent-purple-600" />
                        <span className="text-sm font-medium text-slate-600">Select All Networks</span>
                      </label>
                      {!selectAllNetworks && <ListOfNewNetworkName onChange={setNetworks} defaultValue={networks} clear={clearNetworks} />}
                    </EntityCard>

                    <EntityCard label="Insurance Plan" icon="fa-shield-halved" color="amber" isActive={isInsuranceActive} mode={insuranceMode}
                      onExclusion={() => { if (insuranceMode === "EXCLUSION") { setInsuranceplan([]); setClearInsuranceplan(true); setSelectAllInsurance(false); setInsuranceMode(null); setIsInsuranceActive(false); } else { setInsuranceplan([]); setClearInsuranceplan(true); setSelectAllInsurance(false); setInsuranceMode("EXCLUSION"); setIsInsuranceActive(true); } }}
                      onInclusion={() => { if (insuranceMode === "INCLUSION") { setInsuranceplan([]); setClearInsuranceplan(true); setSelectAllInsurance(false); setInsuranceMode(null); setIsInsuranceActive(false); } else { setInsuranceplan([]); setClearInsuranceplan(true); setSelectAllInsurance(false); setInsuranceMode("INCLUSION"); setIsInsuranceActive(true); } }}
                      onClear={() => { setInsuranceplan([]); setInsuranceMode(null); setIsInsuranceActive(false); setClearInsuranceplan(true); setSelectAllInsurance(false); }}>
                      <label className="flex items-center gap-2 cursor-pointer px-1 py-1 rounded-md hover:bg-slate-50 transition-colors">
                        <input type="checkbox" checked={selectAllInsurance} onChange={(e) => { const c = e.target.checked; preserveScrollCheckbox(e, () => { setSelectAllInsurance(c); if (c) { setInsuranceplan([]); setClearInsuranceplan(true); } }); }} className="w-4 h-4 rounded border-slate-300 accent-amber-600" />
                        <span className="text-sm font-medium text-slate-600">Select All Insurance Plans</span>
                      </label>
                      {!selectAllInsurance && <ListOfInsuranceplanName onChange={setInsuranceplan} defaultValue={insuranceplan} clear={clearInsuranceplan} />}
                    </EntityCard>

                    <EntityCard label="Policy" icon="fa-file-lines" color="emerald" isActive={isPolicyActive} mode={policyMode}
                      onExclusion={() => { if (policyMode === "EXCLUSION") { setPolicy([]); setClearPolicy(true); setSelectAllPolicy(false); setPolicyMode(null); setIsPolicyActive(false); } else { setPolicy([]); setClearPolicy(true); setSelectAllPolicy(false); setPolicyMode("EXCLUSION"); setIsPolicyActive(true); } }}
                      onInclusion={() => { if (policyMode === "INCLUSION") { setPolicy([]); setClearPolicy(true); setSelectAllPolicy(false); setPolicyMode(null); setIsPolicyActive(false); } else { setPolicy([]); setClearPolicy(true); setSelectAllPolicy(false); setPolicyMode("INCLUSION"); setIsPolicyActive(true); } }}
                      onClear={() => { setPolicy([]); setPolicyMode(null); setIsPolicyActive(false); setClearPolicy(true); setSelectAllPolicy(false); }}>
                      <label className="flex items-center gap-2 cursor-pointer px-1 py-1 rounded-md hover:bg-slate-50 transition-colors">
                        <input type="checkbox" checked={selectAllPolicy} onChange={(e) => { const c = e.target.checked; preserveScrollCheckbox(e, () => { setSelectAllPolicy(c); if (c) { setPolicy([]); setClearPolicy(true); } }); }} className="w-4 h-4 rounded border-slate-300 accent-emerald-600" />
                        <span className="text-sm font-medium text-slate-600">Select All Policies</span>
                      </label>
                      {!selectAllPolicy && <PolicyNames onChange={(v: PolicyItem[]) => setPolicy(v)} defaultValue={policy} clear={clearPolicy} />}
                    </EntityCard>

                    <EntityCard label="Patients" icon="fa-users" color="pink" isActive={isPatientActive} mode={patientMode}
                      onExclusion={() => { if (patientMode === "EXCLUSION") { setPatients([]); setClearPatient(true); setSelectAllPatients(false); setPatientMode(null); setIsPatientActive(false); } else { setPatients([]); setClearPatient(true); setSelectAllPatients(false); setPatientMode("EXCLUSION"); setIsPatientActive(true); } }}
                      onInclusion={() => { if (patientMode === "INCLUSION") { setPatients([]); setClearPatient(true); setSelectAllPatients(false); setPatientMode(null); setIsPatientActive(false); } else { setPatients([]); setClearPatient(true); setSelectAllPatients(false); setPatientMode("INCLUSION"); setIsPatientActive(true); } }}
                      onClear={() => { setPatients([]); setPatientMode(null); setIsPatientActive(false); setClearPatient(true); setSelectAllPatients(false); }}>
                      <label className="flex items-center gap-2 cursor-pointer px-1 py-1 rounded-md hover:bg-slate-50 transition-colors">
                        <input type="checkbox" checked={selectAllPatients} onChange={(e) => { const c = e.target.checked; preserveScrollCheckbox(e, () => { setSelectAllPatients(c); if (c) { setPatients([]); setClearPatient(true); } }); }} className="w-4 h-4 rounded border-slate-300 accent-pink-600" />
                        <span className="text-sm font-medium text-slate-600">Select All Patients</span>
                      </label>
                      {!selectAllPatients && <VipPatientSelector onChange={setPatients} defaultValue={patients} clear={clearPatient} />}
                    </EntityCard>

                    <EntityCard label="VIP" icon="fa-star" color="yellow" isActive={isVipActive} mode={vipMode}
                      onExclusion={() => { if (vipMode === "EXCLUSION") { setVip([]); setClearVip(true); setSelectAllVip(false); setVipMode(null); setIsVipActive(false); } else { setVip([]); setClearVip(true); setSelectAllVip(false); setVipMode("EXCLUSION"); setIsVipActive(true); } }}
                      onInclusion={() => { if (vipMode === "INCLUSION") { setVip([]); setClearVip(true); setSelectAllVip(false); setVipMode(null); setIsVipActive(false); } else { setVip([]); setClearVip(true); setSelectAllVip(false); setVipMode("INCLUSION"); setIsVipActive(true); } }}
                      onClear={() => { setVip([]); setVipMode(null); setIsVipActive(false); setClearVip(true); setSelectAllVip(false); }}>
                      <label className="flex items-center gap-2 cursor-pointer px-1 py-1 rounded-md hover:bg-slate-50 transition-colors">
                        <input type="checkbox" checked={selectAllVip} onChange={(e) => { const c = e.target.checked; preserveScrollCheckbox(e, () => { setSelectAllVip(c); if (c) { setVip([]); setClearVip(true); } }); }} className="w-4 h-4 rounded border-slate-300 accent-yellow-600" />
                        <span className="text-sm font-medium text-slate-600">Select All VIP</span>
                      </label>
                      {!selectAllVip && <Vip onChange={setVip} defaultValue={vip} clear={clearVip} />}
                    </EntityCard>

                    <EntityCard label="Payer" icon="fa-building-columns" color="indigo" isActive={isPayerActive} mode={payerMode}
                      onExclusion={() => { if (payerMode === "EXCLUSION") { setPayer([]); setSelectAllPayer(false); setPayerMode(null); setIsPayerActive(false); } else { setPayer([]); setSelectAllPayer(false); setPayerMode("EXCLUSION"); setIsPayerActive(true); } }}
                      onInclusion={() => { if (payerMode === "INCLUSION") { setPayer([]); setSelectAllPayer(false); setPayerMode(null); setIsPayerActive(false); } else { setPayer([]); setSelectAllPayer(false); setPayerMode("INCLUSION"); setIsPayerActive(true); } }}
                      onClear={() => { setPayer([]); setPayerMode(null); setIsPayerActive(false); setSelectAllPayer(false); }}>
                      <label className="flex items-center gap-2 cursor-pointer px-1 py-1 rounded-md hover:bg-slate-50 transition-colors">
                        <input type="checkbox" checked={selectAllPayer} onChange={(e) => { const c = e.target.checked; preserveScrollCheckbox(e, () => { setSelectAllPayer(c); if (c) setPayer([]); }); }} className="w-4 h-4 rounded border-slate-300 accent-indigo-600" />
                        <span className="text-sm font-medium text-slate-600">Select All Payers</span>
                      </label>
                      {!selectAllPayer && <Input value={Payer.join(",")} onChange={(e) => setPayer([e.target.value])} placeholder="Enter Payer" />}
                    </EntityCard>

                    <EntityCard label="User Level" icon="fa-user-gear" color="slate" isActive={isUserActive} mode={userMode}
                      onExclusion={() => { if (userMode === "EXCLUSION") { setUserLevel([]); setSelectAllUser(false); setUserMode(null); setIsUserActive(false); } else { setUserLevel([]); setSelectAllUser(false); setUserMode("EXCLUSION"); setIsUserActive(true); } }}
                      onInclusion={() => { if (userMode === "INCLUSION") { setUserLevel([]); setSelectAllUser(false); setUserMode(null); setIsUserActive(false); } else { setUserLevel([]); setSelectAllUser(false); setUserMode("INCLUSION"); setIsUserActive(true); } }}
                      onClear={() => { setUserLevel([]); setUserMode(null); setIsUserActive(false); setSelectAllUser(false); }}>
                      <label className="flex items-center gap-2 cursor-pointer px-1 py-1 rounded-md hover:bg-slate-50 transition-colors">
                        <input type="checkbox" checked={selectAllUser} onChange={(e) => { const c = e.target.checked; preserveScrollCheckbox(e, () => { setSelectAllUser(c); if (c) setUserLevel([]); }); }} className="w-4 h-4 rounded border-slate-300 accent-slate-600" />
                        <span className="text-sm font-medium text-slate-600">Select All User Levels</span>
                      </label>
                      {!selectAllUser && <Input value={userLevel.join(",")} onChange={(e) => setUserLevel([e.target.value])} placeholder="Enter User Level" />}
                    </EntityCard>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="flex-shrink-0 bg-white border-t border-gray-200 px-6 py-4 flex justify-end gap-3">
            <Button variant="outline" onClick={() => { setEditIndex(null); clear(); setIsDialogOpen(false); }}>Cancel</Button>
            <Button onClick={() => editIndex === null ? addItem() : updateItem(editIndex)} className="bg-blue-700 hover:bg-blue-800 text-white">
              {editIndex === null ? "Add Relation" : "Update Relation"}
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* â•â• ALL CODES DIALOG â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */}
      <Dialog open={allCodesOpen} onOpenChange={setAllCodesOpen}>
        <DialogContent className="max-w-4xl max-h-[80vh]">
          <DialogHeader>
            <DialogTitle className="text-lg font-bold text-blue-900 flex items-center gap-2">
              <i className="fa-solid fa-list" /> {allCodesTitle}
              <span className="ml-auto text-sm font-normal text-gray-500">({allCodesItems.length + allCodesGroups.length} items)</span>
            </DialogTitle>
          </DialogHeader>
          <div className="mt-3 overflow-y-auto max-h-[calc(80vh-120px)] pr-1">
            {allCodesItems.length > 0 && (
              <div className="grid grid-cols-4 gap-2">
                {allCodesItems.map((item, idx) => {
                  const col = getActivityTypeColor(item.type);
                  return (
                    <div key={idx} className={`flex items-center justify-between gap-2 p-2.5 bg-white rounded-lg border hover:shadow-sm transition-all ${col.border}`}>
                      <span className={`font-bold text-sm ${col.text}`}>{item.code}</span>
                      <span className={`text-[10px] font-bold uppercase ${col.text} opacity-70`}>{item.type}</span>
                    </div>
                  );
                })}
              </div>
            )}
            {allCodesGroups.length > 0 && (
              <div className="mt-3">
                <p className="text-xs font-semibold text-gray-500 mb-2">Groups</p>
                <div className="flex flex-wrap gap-2">
                  {allCodesGroups.map((g, idx) => <span key={idx} className="px-3 py-1.5 bg-gray-100 text-gray-800 rounded-lg text-sm font-medium">{g}</span>)}
                </div>
              </div>
            )}
          </div>
          <div className="flex justify-end pt-3 border-t mt-3">
            <Button onClick={() => setAllCodesOpen(false)} className="bg-blue-700 hover:bg-blue-800">Close</Button>
          </div>
        </DialogContent>
      </Dialog>
      {forceDialogOpen && (
  <div style={{ position:"fixed", inset:0, background:"#00000088", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", backdropFilter:"blur(4px)" }}>
    <div style={{ background:"#fff", borderRadius:16, padding:32, width:440, boxShadow:"0 20px 50px rgba(0,0,0,0.3)", border:"1px solid #fecaca" }}>
      <div style={{ display:"flex", flexDirection:"column", alignItems:"center", textAlign:"center", gap:12 }}>
        <div style={{ width:60, height:60, borderRadius:"50%", background:"#fef2f2", display:"flex", alignItems:"center", justifyContent:"center" }}>
          <i className="fa-solid fa-triangle-exclamation" style={{ fontSize:28, color:"#dc2626" }}></i>
        </div>

        {forceAction === "hardDelete" && (
          <>
            <h3 style={{ fontSize:18, fontWeight:700, color:"#1e293b", margin:0 }}>Permanent Delete</h3>
            <p style={{ fontSize:13, color:"#64748b", margin:0, lineHeight:1.6 }}>
              This will <strong style={{ color:"#dc2626" }}>permanently delete</strong> the record.<br />This action <strong>cannot be undone</strong>.
            </p>
            {forceError && (
              <div style={{ width:"100%", background:"#fef9c3", border:"1px solid #fde047", borderRadius:10, padding:"12px 16px", textAlign:"left" }}>
                <div style={{ display:"flex", alignItems:"flex-start", gap:8 }}>
                  <i className="fa-solid fa-circle-info" style={{ color:"#ca8a04", marginTop:2, flexShrink:0 }}></i>
                  <p style={{ fontSize:13, color:"#713f12", margin:0, lineHeight:1.6 }}>{forceError}</p>
                </div>
              </div>
            )}
            <div style={{ display:"flex", gap:10, width:"100%", marginTop:4 }}>
              <button onClick={() => { setForceDialogOpen(false); setForceId(null); setForceError(""); setForceAction(null); }}
                style={{ flex:1, background:"#f1f5f9", color:"#475569", border:"1px solid #e2e8f0", borderRadius:9, padding:12, cursor:"pointer", fontWeight:600, fontSize:13 }}>Cancel</button>
              <button onClick={() => forceId !== null && permanentDeleteItem(forceId, true)}
                style={{ flex:1, background:"#7f1d1d", color:"#fff", border:"none", borderRadius:9, padding:12, cursor:"pointer", fontWeight:700, fontSize:13 }}>
                <i className="fa-solid fa-bolt" style={{ marginRight:8 }}></i>Force Delete Anyway
              </button>
            </div>
          </>
        )}

        {forceAction === "softDelete" && (
          <>
            <h3 style={{ fontSize:18, fontWeight:700, color:"#1e293b", margin:0 }}>Record Is In Use</h3>
            <div style={{ width:"100%", background:"#fef9c3", border:"1px solid #fde047", borderRadius:10, padding:"12px 16px", textAlign:"left" }}>
              <div style={{ display:"flex", alignItems:"flex-start", gap:8 }}>
                <i className="fa-solid fa-circle-info" style={{ color:"#ca8a04", marginTop:2, flexShrink:0 }}></i>
                <p style={{ fontSize:13, color:"#713f12", margin:0, lineHeight:1.6 }}>{forceError}</p>
              </div>
            </div>
            <p style={{ fontSize:13, color:"#64748b", margin:0 }}>Do you want to <strong style={{ color:"#dc2626" }}>force delete</strong> anyway?</p>
            <div style={{ display:"flex", gap:10, width:"100%", marginTop:4 }}>
              <button onClick={() => { setForceDialogOpen(false); setForceId(null); setForceError(""); setForceAction(null); }}
                style={{ flex:1, background:"#f1f5f9", color:"#475569", border:"1px solid #e2e8f0", borderRadius:9, padding:12, cursor:"pointer", fontWeight:600, fontSize:13 }}>Cancel</button>
              <button onClick={() => { if (forceId) forceSoftDelete(forceId); }}
                style={{ flex:1, background:"#dc2626", color:"#fff", border:"none", borderRadius:9, padding:12, cursor:"pointer", fontWeight:700, fontSize:13 }}>
                <i className="fa-solid fa-bolt" style={{ marginRight:8 }}></i>Force Delete
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  </div>
)}

      <Toaster />
    </div>
  );
};

export default ActivitiesReqirePreApprovals;

